import { Link } from "react-router-dom";
import { Lock, Crown } from "lucide-react";

export function FeatureGate({ locked, title, blurb, tier, cta = "Upgrade to unlock", to = "/pricing", testid = "feature-gate", children }) {
  if (!locked) return children;
  return (
    <div data-testid={testid} className="rounded-2xl border border-emerald-500/20 bg-[#0d1730] text-slate-100 grid place-items-center p-8 text-center min-h-[220px] shadow-2xl shadow-emerald-950/40">
      <div className="max-w-sm">
        <div className="w-12 h-12 rounded-2xl bg-emerald-500/10 border border-emerald-500/30 grid place-items-center mx-auto mb-3">
          <Lock className="w-5 h-5 text-emerald-300" />
        </div>
        <h3 className="font-serif text-2xl tracking-tight text-white">{title}</h3>
        {tier && (
          <span data-testid={`${testid}-tier`} className="mt-2 inline-flex items-center gap-1.5 h-6 px-2.5 rounded-full text-[11px] font-semibold bg-emerald-500/10 border border-emerald-500/30 text-emerald-300">
            <Crown className="w-3 h-3" /> Unlocks with {tier}
          </span>
        )}
        <p className="text-sm text-slate-400 mt-2">{blurb}</p>
        <Link
          to={to}
          data-testid={`${testid}-cta`}
          className="mt-4 inline-flex items-center gap-2 h-10 px-5 rounded-xl bg-emerald-500 text-[#04140c] text-sm font-semibold hover:bg-emerald-400 transition-colors"
        >
          {cta}
        </Link>
      </div>
    </div>
  );
}
